exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".v-903c5e2a .tab-content > .tab-pane {\n    display: block;\n}\n.v-903c5e2a .tab-content > .tab-pane.hide {\n    position: absolute;\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./src/Tab.vue
 ** module id = 143
 ** module chunks = 0
 **/